import React, { useEffect, useState } from 'react';

export default function RingChart({
    percent,
    size = 64,
    strokeWidth = 8,
    colorClassName = 'text-success',
    trackClassName = 'text-border',
    centerLabel,
}: {
    percent: number;
    size?: number;
    strokeWidth?: number;
    colorClassName?: string;
    trackClassName?: string;
    centerLabel?: React.ReactNode;
}) {
    const clamped = Math.max(0, Math.min(100, percent));
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const [dashOffset, setDashOffset] = useState(circumference);

    useEffect(() => {
        const offset = circumference - (clamped / 100) * circumference;
        const frame = requestAnimationFrame(() => setDashOffset(offset));
        return () => cancelAnimationFrame(frame);
    }, [clamped, circumference]);

    return (
        <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
            <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    fill="none"
                    stroke="currentColor"
                    className={trackClassName}
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={dashOffset}
                    className={colorClassName}
                    style={{ transition: 'stroke-dashoffset 700ms cubic-bezier(0.33, 1, 0.68, 1)' }}
                />
            </svg>
            {centerLabel && (
                <div className="absolute inset-0 flex items-center justify-center text-xs font-bold text-foreground">
                    {centerLabel}
                </div>
            )}
        </div>
    );
}
